import React, { Component } from "react";
import styled from "styled-components";
import arrow from "../../../../assets/imgs/icons/load-more-arrow.svg";
import DataAPI from "../../../Utils/Api";
import Axios from 'axios';
import {wrapperEndPoint} from "../../../Utils/Api";
//css --------------------------------------------------------------------------------------------------------------------------------------------------------------------

const BankInputBlock = styled.div`
  //background: pink;
  height: auto;
  margin-top: 15px;
  margin-left:12px;
  & .input-block {
    //background: yellow;
    margin-bottom: 16px;
  }
  & .title-label {
    padding-left: 4px;
    color: #000;
    font-size: 13px;
  }
  & .user-select {
    background-color: #fff;
    border: 1px solid #ccc;
    //box-shadow: 0px 5px 12px rgba(0,0,0,0.1);
    border-radius: 5px;
    height: 38px;
    width: 100%;
    color: #CCC;
    padding-left: 10px;
    font-size:13px;
    color: #666666;
    margin-top: 2px;
  }
  select {
    background: url(${arrow}) no-repeat right;
    -webkit-appearance: none;
     background-position-x: 95%;
     cursor:pointer;
  }
  & .user-input {
    background-color: #fff;
    border: 1px solid #ccc;
    //box-shadow: 0px 5px 12px rgba(0,0,0,0.1);
    border-radius: 5px;
    height: 38px;
    width: 100%;
    color: #CCC;
    padding-left: 15px;
    font-size:13px;
    color: #666666;
    margin-top: 4px;
  }
  & .IFSC-block {
  }
`;
const BankSelectionWrapper = styled.div`
  width: 280px;
  @media (max-width: 425px){
    width: 250px;
  }
  @media (max-width: 320px){
    width: 215px;
  }   
`;
//css --------------------------------------------------------------------------------------------------------------------------------------------------------------------

// interface IProps {
//   bankDetailData;
//   overlayMessageToggle;
//   overlayIFSCInputToggle;
//   userSelectedIFSCCode;
//   userSelectedBankName;
//   userSelectedId;
//   userSelectedAccountNumber;
// }

// interface IState {
//   IFSCCode;
//   showOtherBankField;
//   selectedBankIndex;
//   completedForm;
//   bankName;
//   accountNumber;
// }

class InputBankDetails extends Component {

  constructor(props) {
    super(props);

    this.ifscinput = React.createRef();
    this.bankNameDropdown = React.createRef();
    this.state = {
      IFSCCode: this.props.userSelectedIFSCCode,
      showOtherBankField: false,
      selectedBankIndex: this.props.userSelectedId,
      completedForm: false,
      bankName:this.props.userSelectedBankName == ""? "RBL bank": this.props.userSelectedBankName,
      accountNumber: "",
      reAccountNumber: "",
    };
  }

  Editable = (ev) => {
    document.getElementById("IFSCInputField").removeAttribute("value");
  };

  handleIFSCCodeInput = (e) => {
    // setIFSCCode(e.target.value);

    this.ifscinput.current.value = e.target.value;
  };

  updateAccount = (type, e) => {
    if (type == "A") {
      this.setState({
        accountNumber: e.target.value,
      },()=>{
        this.state.bankName === "RBL bank" || this.props.userSelectedIFSCCode === this.ifscinput.current.value ?null:this.ifscinput.current.value = "";
      });
    } else {
      this.setState({
        reAccountNumber: e.target.value,
      },()=>{
        this.state.bankName === "RBL bank" || this.props.userSelectedIFSCCode === this.ifscinput.current.value?null:this.ifscinput.current.value = "";
      });
    }
  };

  handleFindIFSC = () => {
    document.getElementById("IFSCInputField").value = "";
    this.props.overlayIFSCInputToggle(
      this.state.bankName,
      this.state.selectedBankIndex
    );
  };

  handleBankSelection = (e) => {
    let item = document.getElementById("bankName").selectedIndex;
    if(item !== this.state.selectedBankIndex){
      this.setState({IFSCCode: "",accountNumber:"",reAccountNumber: "",selectedBankIndex: item},()=>{
        let acc=document.getElementById("AccNoEntry");
        let re_acc=document.getElementById("AccNoReEntry");
        acc.value="";
        re_acc.value="";
        this.state.bankName === "RBL bank"?null:this.ifscinput.current.value = "";
      });
    }else{
      this.setState({
        selectedBankIndex: item,
      });
    }

    //  console.log(selectedBankIndex)

    if (e.target.value == "Others") {
      this.setState({
        showOtherBankField: true,
        bankName: "",
      });
    } else {
      this.setState({
        showOtherBankField: false,
        bankName: e.target.value,
      });
    }
  };

  handleOtherBankInput = (e) => {
    //add validation
    this.setState({
      bankName: e.target.value,
    });
  };
  preventPaste = (ev) =>{
    ev.preventDefault();
    return false;
  }
  handleProceed = (e) => {
    let message,
      completedForm = false;
    let ifscValidated = false;
    if(this.state.bankName !== "RBL bank"){
    this.setState({IFSCCode: this.ifscinput.current.value,},() => {
        if (
          this.state.bankName.length > 0 &&
          this.state.IFSCCode.length > 0 &&
          this.state.accountNumber.length > 0 &&
          this.state.reAccountNumber.length > 0
        ) {
          if (this.state.accountNumber == this.state.reAccountNumber) {
            //validate IFSC(pending)//
            completedForm = true;
          } else {
            message = "Account numbers do not match";
          }
        } else {
          message = "Please provide your bank details";
        }
    let bankDetails = {
      bankName: this.state.bankName,
      ifsc : this.state.IFSCCode,    
    };
   
    if(completedForm){
      Axios.post(wrapperEndPoint.genericRouterURL,{
        wrapperEndPoint: "/RBLWrapper/rbl/creditCard/CcStplValidateIfsc",
        findIFSC: JSON.stringify(bankDetails),
        },{headers: {
          "Content-Type": "application/json"}
      })
        .then((response)=>{
          var sendData;
          if(response.data.response.status == "success"){
            if(response.data.response.validIfsc === "true"){
              ifscValidated=true;
              sendData = {
                bankName: this.state.bankName,
                accountNumber: this.state.accountNumber,
                IFSCCode: this.state.IFSCCode,
                branchAddress: "NA",
                // branchAddress: response.data.response.branchAddress,
              };
            }else{
              message="Invalid IFSC";
            }  
          }else{
            message = "Something went wrong!"
          }
          if (ifscValidated ) {
            let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
            window["autosubmit"](inputString);
  
            document.getElementById("showPlanData").style.pointerEvents = "none";
            // document.getElementById("showPlanData").style.background = "red";
            document
              .getElementsByClassName("BankDetailsProceed")[0] 
              .classList.add("disabled");
          } else {
            this.props.overlayMessageToggle(message);
            message === "Something went wrong!"?window["logout"](true):null;
          }
        }).catch((error) => {
           console.log(error);
        })
    }else{
      this.props.overlayMessageToggle(message);
    }
  });
}else{
  if (
    this.state.bankName.length > 0 &&
    (this.state.accountNumber.length >= 9 && this.state.accountNumber.length <= 18) &&
    (this.state.reAccountNumber.length >=9 && this.state.reAccountNumber.length <= 18)
  ) {
    this.state.accountNumber == this.state.reAccountNumber?completedForm = true:message = "Account numbers do not match";
  } else {
   
   
    if (
      !(this.state.accountNumber.length >= 9 && this.state.accountNumber.length <= 18) &&
      !(this.state.reAccountNumber.length >=9 && this.state.reAccountNumber.length <= 18)
    ) {

      if( this.state.accountNumber.length == 0 && this.state.reAccountNumber.length ==0){
        message = "Please provide your bank details";
      }else{
        message = "Please enter valid account number";
      }

     
    if ((this.state.accountNumber.length != this.state.reAccountNumber.length)|| (this.state.accountNumber != this.state.reAccountNumber)) {
      message = "Entered account numbers do not match";
    } 


    
    
    }

  }
  //when user try to proceed without entering anything: "Please provide bank details."
  //when acc number range is incorrect: "Please enter valid account number."
  //when both acc numbers does not match: "Entered account numbers do not match."

  if(completedForm){
    let sendData = {
      bankName: this.state.bankName,
      accountNumber: this.state.accountNumber,
      IFSCCode: "NA",
      branchAddress: "NA",
    };
    let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
    document.getElementById("showPlanData").style.pointerEvents = "none";
    document.getElementsByClassName("BankDetailsProceed")[0].classList.add("disabled");
  }else{
    this.props.overlayMessageToggle(message);
  }
}
  };
  componentDidUpdate() {
    if(this.state.bankName != "RBL bank" && this.state.bankName === this.props.userSelectedBankName){
    document.getElementById("IFSCInputField").value == ""
      ? (document.getElementById(
          "IFSCInputField"
        ).value = this.props.userSelectedIFSCCode)
      : null;
    }
  }

  render() {
    let banksDummy = this.props.bankDetailData.bankName ||
      this.props.bankDetailData[0].bankName || [
        "RBL",
        "HDFC",
        "SBI",
        "KOTAK",
        "Other",
      ];
    return (
      <BankSelectionWrapper>
        <div id="showPlanData">
          {/* <div>That's great choice. Enter your bank details in which I can transfer the funds. </div> */}
          <BankInputBlock>
            <div className="input-block">
              <label className="title-label">Bank Name</label>
              <br />
              <select
                className="user-select"
                id="bankName"
                name="bank"
                onChange={(ev) => this.handleBankSelection(ev)}
                ref={this.bankNameDropdown}
              >
                {banksDummy.map((item, i) => {
                  return (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
            <div>
              {this.state.showOtherBankField ? (
                <div className="input-block" style={{ marginTop: "-12px" }}>
                  <input
                    className="user-input"
                    type="text"
                    placeholder="Enter the Bank Name"
                    onChange={(event) => this.handleOtherBankInput(event)}
                  />
                </div>
              ) : null}
            </div>

            <div className="input-block">
              <label className="title-label">Account Number</label>
              <br />
              <input
                className="user-input "
                type="password"
                id="AccNoEntry"
                onPaste={(ev)=>{this.preventPaste(ev)}}
                onChange={(e) => this.updateAccount("A", e)}
                // placeholder="Enter the Account Number"
              />
            </div>
            

            <div className="input-block">
              <label className="title-label">Re-Enter Account Number</label>
              <br />
              <input
                className="user-input "
                id="AccNoReEntry"
                onPaste={(ev)=>{this.preventPaste(ev)}}
                onChange={(e) => this.updateAccount("B", e)}
                //   type="password"
                // placeholder="Re-Enter the Account Number"
              />
            </div>
            {this.state.bankName != "RBL bank" ?
            <div className="IFSC-block">
              <div className="input-block" style={{ display: "inline-block" }}>
                <label className="title-label">IFSC Code</label>
                <br />
                <input
                  ref={this.ifscinput}
                  id="IFSCInputField"
                  className="user-input "
                  onFocus={(event) => this.Editable(event)}
                  onChange={() => this.handleIFSCCodeInput(event)}
                />
              </div>

              <div
                className="ifsc-wrapper "
                onClick={() => this.handleFindIFSC()}
              >
                <p
                  style={{
                    color: "#4bb6dd",
                    textDecoration: "underline",
                    fontWeight: 600,
                  }}
                >
                  Find IFSC
                </p>
              </div>
            </div>
            :null}
          </BankInputBlock>
        </div>
        <ButtonProceed
          className="action-elem"
          onClick={(e) => this.handleProceed(e)}
        >
          Proceed
        </ButtonProceed>
      </BankSelectionWrapper>
    );
  }
}

export default InputBankDetails;

const ButtonProceed = styled.div`
 width: 96%;
`
